export var FWVersionSeverity = /*#__PURE__*/function (FWVersionSeverity) {
  FWVersionSeverity[FWVersionSeverity["NORMAL"] = 1] = "NORMAL";
  FWVersionSeverity[FWVersionSeverity["CRITICAL"] = 2] = "CRITICAL";
  return FWVersionSeverity;
}(FWVersionSeverity || {});
export var BatteryStatus = /*#__PURE__*/function (BatteryStatus) {
  BatteryStatus[BatteryStatus["CRITICALLY_LOW"] = 1] = "CRITICALLY_LOW";
  BatteryStatus[BatteryStatus["LOW"] = 2] = "LOW";
  BatteryStatus[BatteryStatus["MEDIUM"] = 3] = "MEDIUM";
  BatteryStatus[BatteryStatus["HIGH"] = 4] = "HIGH";
  return BatteryStatus;
}(BatteryStatus || {});